module.exports = __webpack_public_path__ + "img/window-volume.8112cf58.svg";